// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"64":"offer-catalog-routing","884":"admin","908":"telephony-routing"}[chunkId] || chunkId) + "." + {"64":"7225825a","87":"15efec20","333":"3f74d52d","357":"31dcc1ed","462":"7105cca3","658":"383258dc","806":"5a12af54","884":"5b2132ad","908":"ea9049e9"}[chunkId] + ".js";
};